<nav [attr.aria-label]="name" *ngIf="!hidden">
  <ul class="pagination"
      [class.pagination-sm]="small"
      [class.pagination-lg]="large"
      [class.justify-content-center]="center"
  >
    <li class="page-item"
        [class.disabled]="pagination.current_page === 1"
    >
      <span class="page-link"
            (click)="jumpTo(pagination.first_page_url)"
      >
        <span aria-hidden="true" class="fa fa-angle-double-left"></span>
        <span class="sr-only">Első</span>
      </span>
    </li>
    <li class="page-item"
        [class.disabled]="!pagination.prev_page_url"
    >
      <span class="page-link"
            (click)="jumpTo(pagination.prev_page_url)"
      >
        <span aria-hidden="true" class="fa fa-angle-left"></span>
        <span class="sr-only">Előző</span>
      </span>
    </li>

    <li *ngFor="let page of Arr(pagination.last_page).fill(1); let i = index"
        class="page-item"
        [class.active]="i + 1 === pagination.current_page"
    ><span class="page-link"
           (click)="jumpToPage(i + 1)"
    >{{ i + 1 }} <span class="sr-only" *ngIf="i + 1 === pagination.current_page">(aktuális)</span></span></li>

    <li class="page-item"
        [class.disabled]="!pagination.next_page_url"
    >
      <span class="page-link"
            (click)="jumpTo(pagination.next_page_url)"
      >
        <span aria-hidden="true" class="fa fa-angle-right"></span>
        <span class="sr-only">Következő</span>
      </span>
    </li>
    <li class="page-item"
        [class.disabled]="pagination.current_page === pagination.last_page"
    >
      <span class="page-link"
            (click)="jumpTo(pagination.last_page_url)"
      >
        <span aria-hidden="true" class="fa fa-angle-double-right"></span>
        <span class="sr-only">Utolsó</span>
      </span>
    </li>
  </ul>
</nav>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/pagination/pagination.component.html